import { GYROMAGNETIC_RATIO } from '../constants/gyromagneticRatio';
/**
 * calculate the frequency of a nucleus with respect to a reference nucleus
 */
export function getFrequency(
/**
 * nucleus to calculate the frequency
 */
nucleus, observedNucleusData) {
    const { nucleus: obsNucleus, frequency } = observedNucleusData;
    checkExistence(nucleus, obsNucleus);
    return ((frequency * GYROMAGNETIC_RATIO[nucleus]) /
        GYROMAGNETIC_RATIO[obsNucleus]);
}
function checkExistence(...nucleus) {
    let nuclei = [];
    for (const n of nucleus) {
        if (!(n in GYROMAGNETIC_RATIO)) {
            nuclei.push(n);
        }
    }
    if (nuclei.length !== 0) {
        throw new Error(`${nuclei.join(' , ')} is not supported`);
    }
}
//# sourceMappingURL=getFrequency.js.map